import store from '../../store';

class EmbedEngine {

    constructor() {
    }

    isEmbeddedSwiset() {
        return store.state.whitelabel.partner !== null;
    }

    allowedPrivateProfile() {
        return this.isEmbeddedSwiset() && store.state.whitelabel.features !== null &&
            store.state.whitelabel.features.findIndex((feature) => feature.feature.name === 'PRIVATE_PROFILE');
    }

    isSingleView(){
        return this.isEmbeddedSwiset() && store.state.whitelabel.features !== null &&
        store.state.whitelabel.features.length === 1;
    }
}

export default new EmbedEngine();
